import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesPopupComponent } from './components/files-popup/files-popup.component';
import { FileTypePipe } from './pipes/file-type.pipe';
import { UploadSidenavComponent } from './components/upload-sidenav/upload-sidenav.component';
import { SharedModule } from '@app-shared';
import { SanitizerPipe } from './pipes/sanitizer.pipe';
import { CreateFolderComponent } from './components/create-folder/create-folder.component';
import { EditSidenavComponent } from './components/edit-sidenav/edit-sidenav.component';
import { FolderSelectComponent } from './components/folder-select/folder-select.component';
import {
    SiSelectComponent,
    SiSelectSimpleOptionsDirective,
    SiSelectSingleValueDirective,
    SiSelectMultiValueDirective
} from '@siemens/element-ng/select';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { SiAccordionComponent, SiCollapsiblePanelComponent } from '@siemens/element-ng/accordion';
import { SiProgressbarComponent } from '@siemens/element-ng/progressbar';
import { SiTreeViewComponent } from '@siemens/element-ng/tree-view';
import { SiLoadingButtonComponent } from '@siemens/element-ng/loading-spinner';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        SiSelectComponent,
        SiSelectSimpleOptionsDirective,
        SiSelectSingleValueDirective,
        SiSelectMultiValueDirective,
        SiFormItemComponent,
        SiAccordionComponent,
        SiCollapsiblePanelComponent,
        SiProgressbarComponent,
        SiTreeViewComponent,
        SiLoadingButtonComponent
    ],
    declarations: [
        FilesPopupComponent,
        FileTypePipe,
        UploadSidenavComponent,
        SanitizerPipe,
        CreateFolderComponent,
        EditSidenavComponent,
        FolderSelectComponent
    ],
    exports: [FilesPopupComponent, UploadSidenavComponent, CreateFolderComponent, EditSidenavComponent]
})
export class UploadModule {}
